import React from 'react';

const FinancialPlanningHealthEmergencyBottomline = () => {
  const benefits = [
    {
      title: "Comprehensive Insurance Strategy",
      description: "Implementing a multi-layered insurance approach with optimized coverage limits, appropriate deductibles and critical illness protection creates a robust financial safety net against catastrophic health expenses."
    },
    {
      title: "Dedicated Emergency Fund",
      description: "Maintaining a liquid health emergency fund separate from general savings provides immediate access to capital for uncovered medical expenses, avoiding debt accumulation during health crises."
    },
    {
      title: "Income Replacement Planning",
      description: "Establishing disability coverage and passive income sources protects your financial stability during recovery periods when earning capacity may be compromised due to health conditions."
    },
    {
      title: "Healthcare Network Optimization",
      description: "Strategically selecting and building relationships with healthcare providers within optimal insurance networks maximizes benefits while minimizing out-of-pocket costs during emergencies."
    }
  ];

  return (
    <div className="w-full bg-gradient-to-br from-[#113262] to-[#1C52A0] py-12 px-8">
      <div className="max-w-6xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6 lg:py-8">
        <div className="text-center mb-16">
          <h2 className="text-white text-2xl md:text-3xl lg:text-4xl font-bold mb-4">
            Bottomline: Benefits of Strategic Health Emergency Planning
          </h2>
          <div className="w-24 h-1 bg-[#F49611] mx-auto mt-4"></div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16">
          {benefits.map((benefit, index) => (
            <div key={index} className="relative">
              {/* Decorative number */}
              <div className="absolute -left-8 top-0 text-6xl font-bold text-[#F49611] opacity-10">
                {index + 1}
              </div>
              
              {/* Content */}
              <div className="relative">
                <div className="flex items-start space-x-4">
                  {/* Vertical line decoration */}
                  <div className="hidden md:block w-1 h-full bg-gradient-to-b from-[#F49611] to-transparent"></div>
                  
                  <div className="flex-1">
                    <h3 className="text-[#F49611] text-xl font-semibold mb-4">
                      {benefit.title}
                    </h3>
                    <p className="text-white/80 text-base leading-relaxed">
                      {benefit.description}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FinancialPlanningHealthEmergencyBottomline;